import React, { useEffect, useState } from "react";

import BackgroundVisuals from "@components/BackgroundVisuals/BackgroundVisuals";
import DashboardRoute from "@route/DashboardRoute";
import NavLinkDelay from "@components/NavLinkDelay/NavLinkDelay";

import "./Dashboard.scss";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { useMst } from "@store/Route";
import { windowLocationOrigin } from "@utils/validation";

const Dashboard = withRouter(
  observer(({ location, history }: RouteComponentProps) => {
    const { reset, landing } = useMst();

    return (
      <div className="Dashboard">
        <DashboardRoute />
      </div>
    );
  })
);

export default Dashboard;
